import React from "react";
import styled from "@emotion/styled";
import { DialogModal } from "../DialogModal/DialogModal";
import { Button } from "../Button";
import { Typography } from "../Typography";

type Props = {
  signInText: string;
  signUpText: string;
  signInHref: string;
  signUpHref: string;
  isOpen: boolean;
  onClose: () => void;
  onSignInClick?: () => void;
  onSignUpClick?: () => void;
};

const Modal = styled(DialogModal)`
  max-width: 712px;
`;

const ModalContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: center;
  align-items: center;
  padding: 72px 0;
`;

const ModalSection = styled.div<{ filledBackground?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 8px;
  align-items: center;
  text-align: center;
  height: 266px;
  width: 276px;
  gap: 26px;
  border: 2px solid ${({ theme }) => theme.colors.mist};
  background-color: ${({ theme, filledBackground }) =>
    filledBackground ? theme.colors.mist : "transparent"};
`;

const Description = styled(Typography)`
  width: 230px;
`;

export const SignUpSignInModal = ({
  isOpen,
  onClose,
  signInText,
  signUpText,
  signInHref,
  signUpHref,
  onSignInClick,
  onSignUpClick,
}: Props) => (
  <Modal
    onClose={onClose}
    isOpen={isOpen}
    inline
    dataTestId="exposed-impact-shop-modal"
  >
    <ModalContainer>
      <ModalSection filledBackground>
        <Typography use="dashboardTitle2">Existing customers</Typography>
        <Description use="body1">{signInText}</Description>
        <Button
          primary
          href={signInHref}
          text="Sign in"
          onClick={onSignInClick}
        />
      </ModalSection>
      <ModalSection>
        <Typography use="dashboardTitle2">New customers</Typography>
        <Description use="body1">{signUpText}</Description>
        <Button
          darkGreen
          href={signUpHref}
          text="Register now"
          onClick={onSignUpClick}
        />
      </ModalSection>
    </ModalContainer>
  </Modal>
);
